module.exports = __webpack_public_path__ + "media/images/billing/adyen-brands-83abf484d6499eb53e925165a1dbb9c6.svg";